var _a;
import { fetchSignToken, getAPIVolcEnv } from "./request";
import { getJwtUserInfo, getJwt, currentDomainID, defaultCloudLocale } from "@bytecloud/common-lib";
import { VolcEnvEnum } from "../types";
import { generateJwtPromisesCacheMap } from "../bytecloud/jwt";
import { getProxyAddHeader, getGatewayDomainId } from "../utils";
import {
  MULTI_CLOUD_PROXY_HEADER_QUERY_KEY
} from "@bytecloud/volcengine-lib";
import { getVolcMixtureLoginUrl } from "./login";
import { getCozeSSOUserInfo, checkCozeLogin } from "./coze";
import qs from "qs";
const iframeOriginMap = {
  online: "https://console4bytecloud.volcpartner.com",
  stable: "https://console4bytecloud.volcpartner.net",
  byteplus: "https://console.byteplus.com",
  coze: "https://cloud-coze.bytedance.net",
  coze_code: "https://code.cloud-coze.bytedance.net"
};
function setIframeOrigin(volcEnv, origin) {
  iframeOriginMap[volcEnv] = origin;
}
const volcCommonOriginMap = {
  online: "https://console.volcengine.com",
  stable: "https://console-stable.volcanicengine.com",
  byteplus: "https://console.byteplus.com",
  coze: "https://cloud-coze.bytedance.net",
  coze_code: "https://code.cloud-coze.bytedance.net"
};
const getIframeOrigin = (volcEnv) => iframeOriginMap[volcEnv];
const selfEndPointMap = {
  online: "https://cloud-volc.bytedance.net",
  stable: "https://cloud-volc-boe.bytedance.net",
  byteplus: "https://cloud-volc.byteintl.net",
  coze: "https://cloud-volc.bytedance.net",
  coze_code: "https://code.cloud-volc.bytedance.net"
};
const getSelfHostedVolcEndPoint = (volcEnv) => selfEndPointMap[volcEnv];
const getVolcCommonOrigin = (volcEnv) => volcCommonOriginMap[volcEnv];
const volcPortalOrigin = "https://www.volcengine.com";
const receivePrefix = "volc_2_bytecloud_event";
const sendPrefix = "bytecloud_2_volc_event";
const injectQueryList = [
  "hiddenNavbar",
  "hiddenSidebar",
  "x-bytecloud-jwt",
  "x-bytecloud-jwt-map",
  "x-bytecloud-proxy-rule",
  "user_locale",
  "projectName",
  MULTI_CLOUD_PROXY_HEADER_QUERY_KEY
];
const queryFilterSet = new Set(injectQueryList);
async function generateMultiCloudProxyHtmlUrl(options) {
  const volcAccountId = options.volcAccountId || getDefaultVolcAccountId();
  if (!volcAccountId) {
    throw new Error("volcAccountId is undefined");
  }
  const bcParams = { ...options.baseSearchParams };
  const domainId = options.domainId || currentDomainID;
  if (!domainId) {
    throw new Error("currentDomainID is undefined");
  }
  const jwt = await getJwt(getGatewayDomainId(options.volcEnv) || domainId);
  generateMultiCloudProxyHeaderSearchQuery(
    {
      jwt,
      volcAccountId,
      volcEnv: options.volcEnv,
      productType: options.productType,
      signCookieVersion: options.signCookieVersion || 1,
      resourceBytetree: options.resourceBytetree,
      samlType: options.samlType || "user",
      hostname: options.hostname
    },
    bcParams
  );
  let directUrl = `${options.proxyEndPointHost + options.volcPath}`;
  const directUrlSearch = stringifySearchParams(bcParams);
  if (directUrlSearch.length > 0) {
    directUrl = `${directUrl}?${directUrlSearch}`;
  }
  if (options.hash && typeof options.hash === "string") {
    directUrl = directUrl + options.hash;
  }
  return directUrl;
}
function setSearchParam(params, key, value) {
  params[key] = value;
}
function appendSearchParam(params, key, value) {
  const currentValue = params[key];
  if (currentValue === void 0) {
    params[key] = value;
    return;
  }
  if (Array.isArray(currentValue)) {
    params[key] = [...currentValue, value];
    return;
  }
  params[key] = [currentValue, value];
}
function stringifySearchParams(params) {
  return qs.stringify(params, { arrayFormat: "repeat" });
}
async function generateMultiCloudProxyHeaderSearchQuery(options, baseSearchParams) {
  const headerMap = {
    "x-jwt-token": options.jwt,
    "x-bcgw-accountmeta": `main_account_id=${options.volcAccountId}`,
    "x-bcgw-sts-type": options.stsType || "samlSts",
    "x-bcgw-producttype": options.productType,
    "volc-env": getAPIVolcEnv(options.volcEnv),
    "x-cloud-volc-saml-type": options.samlType || "user"
  };
  if (options.resourceBytetree) {
    headerMap["x-bcgw-resource-bytetree"] = options.resourceBytetree.toString();
  }
  if (options.signCookieVersion === 2 || options.samlType === "role") {
    headerMap["x-bcgw-volc-sign-cookie-v2"] = "true";
  } else {
    headerMap["x-bcgw-volc-sign-cookie"] = "true";
  }
  if (options.hostname) {
    headerMap["x-bcgw-volc-sign-hostname"] = options.hostname;
  }
  setSearchParam(baseSearchParams, MULTI_CLOUD_PROXY_HEADER_QUERY_KEY, JSON.stringify(headerMap));
  setSearchParam(baseSearchParams, "user_locale", defaultCloudLocale);
  return baseSearchParams;
}
async function generateSelfHostedVolcLoginUrl$Login2(options, loginStatusManager) {
  var _a2;
  const skipLogin = (_a2 = options.skipLogin) != null ? _a2 : false;
  const volcAccountId = options.volcAccountId || getDefaultVolcAccountId();
  if (!volcAccountId) {
    throw new Error("volcAccountId is undefined");
  }
  const bcParams = { ...options.baseSearchParams };
  const domainId = options.domainId || currentDomainID;
  if (!domainId) {
    throw new Error("currentDomainID is undefined");
  }
  const jwt = await getJwt(domainId);
  await generateVolcIframeSearchParams(
    {
      jwt,
      volcAccountId,
      volcEnv: options.volcEnv,
      productType: options.productType,
      samlType: options.samlType || "user",
      proxyRule: {
        hijackTOPSource: options.hijackTOPSource,
        hijackTOPTarget: options.hijackTOPTarget,
        hijackVolcConsoleAPI: options.hijackVolcConsoleAPI,
        ignoreHijackValue: options.ignoreHijackValue,
        volcBasePath: options.volcBasePath,
        resourceBytetree: options.resourceBytetree,
        signCookieVersion: options.signCookieVersion
      }
    },
    bcParams,
    options.flags || { jwtMap: false, proxyRule: false, jwt: false, hideHeaders: false }
  );
  const userInfo = await getJwtUserInfo();
  if (!userInfo) {
    throw new Error("userInfo is undefined, cannot get user info");
  }
  let directUrl = `${options.proxyEndPointHost + options.volcPath}`;
  const directUrlSearch = stringifySearchParams(bcParams);
  if (directUrlSearch.length > 0) {
    directUrl = `${directUrl}?${directUrlSearch}`;
  }
  if (options.hash && typeof options.hash === "string") {
    directUrl = directUrl + options.hash;
  }
  if (skipLogin && !loginStatusManager.checkLoginExpired()) {
    return {
      directUrl,
      validity: true
    };
  }
  let redirectUrl = options.volcPath;
  const redirectUrlSearch = stringifySearchParams(bcParams);
  if (redirectUrlSearch.length > 0) {
    redirectUrl = `${redirectUrl}?${redirectUrlSearch}`;
  }
  if (options.hash && typeof options.hash === "string") {
    redirectUrl = redirectUrl + options.hash;
  }
  const loginUrl = await getVolcMixtureLoginUrl({
    host: options.proxyEndPointHost,
    volcAccountId,
    redirectUrl
  });
  if (skipLogin) {
    loginStatusManager.writeSignInTokenExpireTime(
      6 * 60 * 60
      /** 6 hours */
    );
  }
  return {
    directUrl,
    validity: false,
    loginUrl
  };
}
const cozeLoginInfoKey = "BYTECLOUD_COZE_LOGIN_INFO";
function getCozeLoginInfo() {
  try {
    const cozeLoginInfo = localStorage.getItem(cozeLoginInfoKey);
    if (cozeLoginInfo) {
      return JSON.parse(cozeLoginInfo);
    }
  } catch (error) {
    console.error("Failed to get Coze login info", error);
  }
  return null;
}
function setCozeLoginCache(info) {
  if (!info) {
    localStorage.removeItem(cozeLoginInfoKey);
    return;
  }
  localStorage.setItem(cozeLoginInfoKey, JSON.stringify(info));
}
function getCozeLoginUrlOld(options) {
  const { redirect, volcAccountId, instanceName, userName } = options;
  const volcCICtx = qs.stringify({
    userType: "BasicUser",
    autoConfirm: "1",
    companyAlias: volcAccountId,
    instanceName,
    userName
  });
  const searchParams = qs.stringify({
    platform: "volcano",
    volc_ci_ctx: volcCICtx,
    redirect
  });
  return `https://cloud-coze.bytedance.net/sign/oauth?${searchParams}`;
}
function getCozeLoginUrl(options) {
  const { redirect } = options;
  return `https://sso.bytedance.com/cas/login?service=https%3A%2F%2Fcloud-coze.bytedance.net%2Fapi%2Fdeveloper%2Fcas%2Flogin%3Fnext%3D${encodeURIComponent(
    encodeURIComponent(redirect)
  )}`;
}
async function getCozeInitUrl(options) {
  const { redirect, volcAccountId, instanceName, forceLogin, volcEnv } = options;
  const cozeLoginInfo = getCozeLoginInfo();
  const userInfo = await getJwtUserInfo();
  if (!userInfo) {
    throw new Error("userInfo is undefined, cannot get user info");
  }
  const iframeOrigin = getIframeOrigin(volcEnv || VolcEnvEnum.coze);
  const redirectHref = redirect.startsWith("http") ? redirect : `${iframeOrigin}${redirect}`;
  if (cozeLoginInfo && Date.now() - cozeLoginInfo.loginTime < 1e3 * 60 * 60 * 24 * 3 && cozeLoginInfo.volcAccountId === volcAccountId && cozeLoginInfo.instanceName === instanceName) {
    const [cozeUserInfo, cozeLogin] = await Promise.all([getCozeSSOUserInfo(), checkCozeLogin()]);
    if (!forceLogin && cozeLogin && cozeUserInfo && userInfo.username === cozeUserInfo.username) {
      return redirectHref;
    }
  }
  setCozeLoginCache();
  return getCozeLoginUrl({
    redirect: redirectHref,
    volcAccountId,
    instanceName,
    userName: userInfo.username
  });
}
async function generateSelfHostedVolcLoginUrl(options, loginStatusManager) {
  var _a2;
  const fakeRedirectUrl = "http://console.volcengine.com";
  const skipLogin = (_a2 = options.skipLogin) != null ? _a2 : false;
  const volcAccountId = options.volcAccountId || getDefaultVolcAccountId();
  if (!volcAccountId) {
    throw new Error("volcAccountId is undefined");
  }
  const bcParams = { ...options.baseSearchParams };
  const domainId = options.domainId || currentDomainID;
  if (!domainId) {
    throw new Error("currentDomainID is undefined");
  }
  const jwt = await getJwt(domainId);
  await generateVolcIframeSearchParams(
    {
      jwt,
      volcAccountId,
      volcEnv: options.volcEnv,
      productType: options.productType,
      samlType: options.samlType,
      proxyRule: {
        hijackTOPSource: options.hijackTOPSource,
        hijackTOPTarget: options.hijackTOPTarget,
        hijackVolcConsoleAPI: options.hijackVolcConsoleAPI,
        ignoreHijackValue: options.ignoreHijackValue,
        volcBasePath: options.volcBasePath,
        resourceBytetree: options.resourceBytetree,
        signCookieVersion: options.signCookieVersion
      }
    },
    bcParams,
    options.flags || { jwtMap: false, proxyRule: false, jwt: false, hideHeaders: false }
  );
  const userInfo = await getJwtUserInfo();
  if (!userInfo) {
    throw new Error("userInfo is undefined, cannot get user info");
  }
  let directUrl = `${options.proxyEndPointHost + options.volcPath}`;
  const directUrlSearch = stringifySearchParams(bcParams);
  if (directUrlSearch.length > 0) {
    directUrl = `${directUrl}?${directUrlSearch}`;
  }
  if (options.hash && typeof options.hash === "string") {
    directUrl = directUrl + options.hash;
  }
  if (skipLogin && !loginStatusManager.checkLoginExpired()) {
    return {
      directUrl,
      validity: true
    };
  }
  const { signInToken, sessionDuration } = await getSignInToken({
    volcURL: `${fakeRedirectUrl}${options.volcPath || "/home"}`,
    volcAccountId,
    volcEnv: options.volcEnv
  });
  if (skipLogin) {
    loginStatusManager.writeSignInTokenExpireTime(sessionDuration);
  }
  let redirectUrl = options.volcPath;
  const redirectUrlSearch = stringifySearchParams(bcParams);
  if (redirectUrlSearch.length > 0) {
    redirectUrl = `${redirectUrl}?${redirectUrlSearch}`;
  }
  if (options.hash && typeof options.hash === "string") {
    redirectUrl = redirectUrl + options.hash;
  }
  return {
    directUrl,
    validity: false,
    loginUrl: `${options.proxyEndPointHost}/api/passport/login/loginWithSigninToken?signinToken=${encodeURIComponent(
      signInToken
    )}&redirectURI=${encodeURIComponent(redirectUrl)}`
  };
}
async function generateVolcIframeSearchParams(options, params, searchUseOptions) {
  if (searchUseOptions.hideHeaders) {
    appendSearchParam(params, "hiddenSidebar", "true");
    appendSearchParam(params, "user_locale", defaultCloudLocale);
  }
  if (searchUseOptions.jwt) {
    setSearchParam(params, "x-bytecloud-jwt", options.jwt);
  }
  if (searchUseOptions.jwtMap) {
    const jwtMap = await generateJwtPromisesCacheMap();
    setSearchParam(params, "x-bytecloud-jwt-map", encodeURIComponent(JSON.stringify(jwtMap)));
  }
  if (searchUseOptions.proxyRule) {
    const { proxyRule } = options;
    if (proxyRule) {
      const defaultHijackTopSource = proxyRule.hijackTOPSource || "^/api/top";
      const { hijackTOPTarget, hijackVolcConsoleAPI, volcBasePath, resourceBytetree, signCookieVersion } = proxyRule;
      if (hijackTOPTarget) {
        const ruleValue = {
          searchValue: defaultHijackTopSource.toString(),
          ignoreValue: proxyRule.ignoreHijackValue ? proxyRule.ignoreHijackValue.toString() : "",
          replaceValue: hijackTOPTarget,
          addedHeaders: getProxyAddHeader({
            ...options,
            volcBasePath,
            productType: options.productType,
            hijackVolcConsoleAPI,
            resourceBytetree,
            signCookieVersion,
            samlType: options.samlType
          })
        };
        setSearchParam(
          params,
          "x-bytecloud-proxy-rule",
          encodeURIComponent(JSON.stringify([{ type: "url-rule", value: ruleValue }]))
        );
      } else {
        const ruleValue = {
          matcher: "^/api/top",
          headers: {
            "x-jwt-token": options.jwt
          }
        };
        setSearchParam(
          params,
          "x-bytecloud-proxy-rule",
          encodeURIComponent(JSON.stringify([{ type: "header-rule", value: ruleValue }]))
        );
      }
    }
  }
}
async function getSignInToken({
  volcURL,
  volcAccountId,
  volcEnv
}) {
  const volcURLObj = new URL(volcURL);
  const { sign_in_token, session_duration } = await fetchSignToken(volcURLObj.href, volcAccountId, volcEnv);
  return { signInToken: sign_in_token, sessionDuration: session_duration };
}
async function getVolcIframeUrlSimple({
  volcURL,
  volcAccountId,
  volcEnv = VolcEnvEnum.online
}) {
  const volcURLObj = new URL(volcURL);
  const domainId = getGatewayDomainId(volcEnv);
  const userInfo = await getJwtUserInfo(domainId);
  if (!userInfo) {
    throw new Error("userInfo is undefined, cannot get user info");
  }
  const { sign_in_token } = await fetchSignToken(volcURLObj.href, volcAccountId, volcEnv);
  return `${volcURLObj.origin}/api/passport/login/loginWithSigninToken?signinToken=${encodeURIComponent(
    sign_in_token
  )}&redirectURI=${encodeURIComponent(volcURLObj.pathname + volcURLObj.search)}`;
}
async function getVolcIframeUrl({
  volcURL,
  volcAccountId,
  volcEnv,
  skipLogin,
  flags
}, loginStatusManager) {
  if (currentDomainID === void 0) {
    return volcURL;
  }
  const volcURLObj = new URL(volcURL);
  const iframeHostname = new URL(getIframeOrigin(volcEnv)).hostname;
  if (volcURLObj.hostname !== iframeHostname) {
    volcURLObj.hostname = iframeHostname;
  }
  const searchParams = qs.parse(volcURLObj.search, { ignoreQueryPrefix: true });
  injectQueryList.forEach((key) => {
    if (searchParams[key] !== void 0) {
      delete searchParams[key];
    }
  });
  Object.keys(searchParams).forEach((key) => {
    if (queryFilterSet.has(key) || key.startsWith("x-bc")) {
      delete searchParams[key];
    }
  });
  appendSearchParam(searchParams, "hiddenSidebar", "true");
  appendSearchParam(searchParams, "user_locale", defaultCloudLocale);
  const jwt = await getJwt(currentDomainID);
  appendSearchParam(searchParams, "x-bytecloud-jwt", jwt);
  try {
    const jwtMap = await generateJwtPromisesCacheMap();
    if (flags.jwtMap) {
      appendSearchParam(searchParams, "x-bytecloud-jwt-map", encodeURIComponent(JSON.stringify(jwtMap)));
    }
  } catch (e) {
  }
  const userInfo = await getJwtUserInfo();
  if (!userInfo) {
    throw new Error("userInfo is undefined, cannot get user info");
  }
  if (skipLogin && !loginStatusManager.checkLoginExpired()) {
    return volcURLObj.href;
  }
  const { sign_in_token, session_duration } = await fetchSignToken(volcURLObj.href, volcAccountId, volcEnv);
  if (skipLogin) {
    loginStatusManager.writeSignInTokenExpireTime(session_duration);
  }
  return `${volcURLObj.origin}/api/passport/login/loginWithSigninToken?signinToken=${encodeURIComponent(
    sign_in_token
  )}&redirectURI=${encodeURIComponent(volcURLObj.pathname + volcURLObj.search)}`;
}
const bytecloudContext = (_a = window.getBytecloudContext) == null ? void 0 : _a.call(window, "demo_app");
function getDefaultVolcAccountId() {
  try {
    const resourceAccountItemConfig = (bytecloudContext == null ? void 0 : bytecloudContext.getResourceConfig().resourceAccountItemConfig) || {};
    if (resourceAccountItemConfig.hasPermission !== true) {
      throw new Error("No permission");
    }
    return resourceAccountItemConfig.mainAccountID;
  } catch (e) {
    console.error(e);
    throw new Error("Error when getting default account id.");
  }
}
function getVolcengineConsoleLoginIframeUrl(loginStatusManager, volcURL, skipLogin, volcEnv, flags, inputVolcAccountId) {
  const volcAccountId = inputVolcAccountId || getDefaultVolcAccountId();
  if (volcAccountId === void 0) {
    throw new Error("volcAccountId is undefined");
  }
  return getVolcIframeUrl({ volcURL, volcAccountId, volcEnv, skipLogin, flags }, loginStatusManager);
}
async function getVolcDocsURL(url) {
  try {
    const response = await fetch(
      `https://cloud.bytedance.net/api/v1/cloud_developer/api/open/v1/link?url=${encodeURIComponent(url)}`
    );
    const body = await response.json();
    return body.data.doc_url || url;
  } catch (e) {
    return url;
  }
}
export {
  generateMultiCloudProxyHeaderSearchQuery,
  generateMultiCloudProxyHtmlUrl,
  generateSelfHostedVolcLoginUrl,
  generateSelfHostedVolcLoginUrl$Login2,
  generateVolcIframeSearchParams,
  getCozeInitUrl,
  getCozeLoginUrl,
  getCozeLoginUrlOld,
  getDefaultVolcAccountId,
  getIframeOrigin,
  getSelfHostedVolcEndPoint,
  getSignInToken,
  getVolcCommonOrigin,
  getVolcDocsURL,
  getVolcIframeUrl,
  getVolcIframeUrlSimple,
  getVolcengineConsoleLoginIframeUrl,
  iframeOriginMap,
  injectQueryList,
  queryFilterSet,
  receivePrefix,
  selfEndPointMap,
  sendPrefix,
  setCozeLoginCache,
  setIframeOrigin,
  volcCommonOriginMap,
  volcPortalOrigin
};
